export default __webpack_public_path__ + "static/media/f_email.64b03e9e.svg";